import { render } from "./Examinationtime.vue?vue&type=template&id=7370237e&scoped=true"
import script from "./Examinationtime.vue?vue&type=script&lang=js"
export * from "./Examinationtime.vue?vue&type=script&lang=js"

import "./Examinationtime.vue?vue&type=style&index=0&id=7370237e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7370237e"]])

export default __exports__